@if (botComponent.isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
}
@if (!botComponent.isLoading) {
  <div>
    <ng-container *ngTemplateOutlet="botParamsTemplate"></ng-container>
  </div>
}
